import { useTranslation } from "react-i18next";
import { useFilterInitialization } from "./hooks/useFilterInitialization";
import { useFilters } from "../FilterContext";

export const AssetViewToggleFilter = () => {
	const { t } = useTranslation();
	const { initialValues } = useFilters();

	useFilterInitialization("assetViewToggle", [], {
		getDefaultValue: () => {
			const storedView = initialValues.assetViewToggle;

			if (storedView && (storedView === "tree" || storedView === "list")) {
				return {
					id: storedView,
					name: storedView === "tree" ? t("option.treeView") : t("option.listView"),
				};
			}

			return { id: "tree", name: t("option.treeView") };
		},
		getParams: (viewOption) => {
			return { assetViewToggle: viewOption.id || "tree" };
		},
		waitForData: false,
	});

	// Pseudo-filter — doesn't render anything
	return null;
};
